<template>
  <span><a v-bind:href="buildUrl">{{buildName}}</a></span>
</template>

<script>
export default {
  name: 'DeviceBuild',
  props: ['deviceType'],
  data () {
    return {
      buildName: '',
      buildUrl: '',
      devices: {
        'demo_uk_mp200_wifi': 'aibms-demo-mp200-all',
        'demo_uk_v3_mid_countertop_ethernet_wifi': 'aibms-demo-vega3000-all',
        'demo_uk_v3_mid_pinpad_ethernet': 'aibms-demo-vega3000-all',
        'demo_uk_v3_portable_wifi': 'aibms-demo-vega3000-all',
        'demo_roi_mp200': 'aibms-demo-mp200-all',
        'demo_roi_v3_mid_countertop_ethernet_wifi': 'aibms-demo-vega3000-all',
        'demo_roi_v3_mid_pinpad_ethernet': 'aibms-demo-vega3000-all',
        'demo_roi_v3_portable_wifi': 'aibms-demo-vega3000-all',
        'aibms_uk_mp200_pp': 'aibms-uk-mp200-all',
        'aibms_uk_v3_mid_countertop_ethernet_wifi_pp': 'aibms-uk-vega3000-all',
        'aibms_uk_v3_mid_countertop_ethernet_wifi_amt': 'aibms-uk-vega3000-all',
        'aibms_uk_v3_mid_pinpad_ethernet_pp': 'aibms-uk-vega3000-all',
        'aibms_uk_v3_portable_wifi_pp': 'aibms-uk-vega3000-all',
        'aibms_roi_mp200_pp': 'aibms-ie-mp200-all',
        'aibms_roi_v3_mid_countertop_ethernet_wifi_pp': 'aibms-ie-vega3000-all',
        'aibms_roi_v3_mid_countertop_ethernet_wifi_amt': 'aibms-ie-vega3000-all',
        'aibms_roi_v3_mid_pinpad_ethernet_pp': 'aibms-ie-vega3000-all',
        'aibms_roi_v3_portable_wifi_pp': 'aibms-ie-vega3000-all',
        'barclays_uk_v3_mid_countertop_ethernet_wifi_pp': 'barclaycard-uk-vega3000-all',
        'barclays_uk_v3_mid_pinpad_ethernet_pp': 'barclaycard-uk-vega3000-all',
        'barclays_uk_v3_portable_wifi_pp': 'barclaycard-uk-vega3000-all',
        'aibms_uk_mp200_gb': 'goodbox-uk-mp200-all'
      }
    }
  },
  computed: {
    deviceCode: function () {
      return this.deviceType
    }
  },
  mounted () {
    this.buildName = this.devices[this.deviceCode] || 'none'
    this.buildUrl = 'https://kineticsmart.com/download/files/kinetic_go/' + this.buildName + '.zip'
  }
}
</script>

<style scoped>

</style>
